import { render, staticRenderFns } from "./StepLawyers.vue?vue&type=template&id=e93de3e8&"
import script from "./StepLawyers.vue?vue&type=script&lang=js&"
export * from "./StepLawyers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports